module.exports = __webpack_public_path__ + "static/media/india.fd9f0a79.png";